import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { PageProject } from "@/apps/page/page-project.interface";

const logger = makeLogger("customDomainsService");

const ENDPOINT = "/pages/custom-domains";

export const customDomainsService = {
    getBaseDomain() {
        return process.env.VUE_APP_ORIGIN || "";
    },
    getAll(pageUuid: PageProject["uuid"]) {
        logger.trace("Fetching all custom domains");
        return ajaxCall.get(`${ENDPOINT}/${pageUuid}`).catch(handleErrorByMessage());
    },
    add(pageUuid: PageProject["uuid"], domain: string) {
        logger.trace("Adding custom domain", domain);
        return ajaxCall
            .post(`${ENDPOINT}/${pageUuid}`, { domain })
            .catch(handleErrorByMessage({ rethrow: true }));
    },
    remove(domain: string) {
        logger.trace("Removing custom domain", domain);
        return ajaxCall.delete(`${ENDPOINT}/${domain}`).catch(handleErrorByMessage());
    },
};
